import { useQuery } from '@tanstack/react-query'

import { TAction } from '~/features/scenarios/models'
import { queryKeys } from '~/features/scenarios/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import { store } from '~/store'

const getActions = (orgId: string) => {
  return HttpService.get<TAction[]>(
    {
      path: EServerPath.actions,
      query: { orgId },
    },
    EHttpService.scenarios,
  ).then((res) => res.data)
}

const useGetActions = () => {
  const orgId = store((state) => state.user.organizationId)

  return useQuery({
    queryKey: queryKeys.actions(orgId),
    queryFn: () => getActions(orgId),
  })
}

export default useGetActions
